"use client"

import { Dashboard } from "@/components/dashboard/index"

export default function DashboardPage() {
  return <Dashboard />
}